import React from 'react';
import FormValidationError from '../../../forms/utilities/validation-error';

export default function ValidationError({ errors, name }) {
    if (!errors || !errors[name]) {
        return null;
    }

    return <FormValidationError>
        { errors[name] }
    </FormValidationError>
}
